import { useState } from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import QrReader from 'react-qr-reader';

export function SerialCheckForm({
  alert,
  disabled = {},
  onSubmit,
  values = {},
}) {
  const { register, handleSubmit, setValue } = useForm();
  const [scanQr, setScanQr] = useState(false);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {alert ? alert : null}
      <Form.Group controlId="serialCheckFormProductId">
        <Form.Label>Serial</Form.Label>
        <Form.Control
          defaultValue={values.productId}
          disabled={disabled.productId}
          name="productId"
          placeholder="Nhập Serial"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group>
        <Button
          onClick={() => {
            setScanQr(!scanQr);
          }}
          variant="danger"
        >
          {scanQr ? 'Tắt Quét Mã QR' : 'Quét Mã QR'}
        </Button>
        {scanQr && (
          <QrReader
            delay={300}
            onError={() => {
              setScanQr(false);
              alert('Vui lòng cấp quyền camera để sử dụng tính năng này!');
            }}
            onScan={(data) => {
              if (data) {
                setValue('productId', data);
                setScanQr(false);
              }
            }}
            style={{ width: '100%', marginTop: '0.5rem' }}
          />
        )}
      </Form.Group>
      <Button type="submit" variant="primary">
        Kiểm Tra
      </Button>
    </Form>
  );
}
